import { useEffect, useState } from "react";
import ReactApexChart from "react-apexcharts";
import { Container } from "react-bootstrap";
import { PageLoader } from "../../../../Components/NoDataFoundTable/NoDataFoundTable";

const HeatmapChartStatistics = ({ siteHitMap = [], siteHitMapLoader }) => {

  function normalizeHeatmapData(data) {
    const allXValues = new Set();
    data.forEach(site => {
      site.data.forEach(item => {
        allXValues.add(item.x);
      });
    });

    const normalized = data.map(site => {
      const siteDataMap = new Map(site.data.map(item => [item.x, item.y]));
      const fullData = Array.from(allXValues).map(x => ({
        x,
        y: siteDataMap.get(x) || null,
      }));
      return {
        ...site,
        data: fullData,
      };
    });

    return normalized;
  }

  const [chartData, setChartData] = useState({
    series: [],
    options: {
      chart: {
        height: 350,
        type: "heatmap",
      },
      dataLabels: {
        enabled: true,
        style: {
          colors: ["#000000"], // data label text color
        },
      },
      colors: ["#006400"],
      xaxis: {
        labels: {
          rotate: -45,
        },
        tooltip: {
          enabled: true,
        },
      },
    },
  });

  useEffect(() => {
    if (siteHitMap && siteHitMap.length > 0) {
      const normalized = normalizeHeatmapData(siteHitMap); 
      setChartData((prev) => ({
        ...prev,
        series: normalized,
      }));
    }
  }, [siteHitMap]);

  return (
    <>
      <h5 className="fw-bold mb-0 text-center w-100 mt-2">SDV Chart</h5>
      {siteHitMapLoader ?
        <div
          className="hstack justify-content-center"
          style={{ height: 350 }}
        >
          <PageLoader/>
        </div>
        :
        <Container fluid className="overflow-auto py-1">
          <div
            style={chartData.series[0]?.data?.length >= 10 ? {
              width: `${chartData.series[0]?.data?.length * 100 || 500}px`,
            } : {}}
          >
            {chartData.series.length > 0 && (
              <ReactApexChart
                options={chartData.options}
                series={chartData.series}
                type="heatmap"
                height={350}
              />
            )}
          </div>
        </Container>}
    </>
  );
};

export default HeatmapChartStatistics;